import Role from 'pages/employmanagment/role';
export const EmployRole = () => {
  return <Role />;
};
